import type { ResolveSystemAgentDetailsBasePathParams } from '../types';

const resolveSystemAgentDetailsBasePath = ({
    agentId,
    systemAgentId,
}: ResolveSystemAgentDetailsBasePathParams): string => {
    if (agentId && agentId.length > 0) {
        return `/agents/${agentId}/system-agents/${systemAgentId}`;
    }
    return `/admin/system-agents/${systemAgentId}`;
};

export default resolveSystemAgentDetailsBasePath;
